<template>
    <div>
        <div v-if="animationStyle === 'bars'" class="spinner" :class="classes ? classes : ''">
            <div class="rect1"></div>
            <div class="rect2"></div>
            <div class="rect3"></div>
            <div class="rect4"></div>
            <div class="rect5"></div>
            <div class="rect6"></div>
            <div class="rect7"></div>
            <div class="rect8"></div>
        </div>
        <div v-if="animationStyle === 'spinner'">
            <i class="fa fa-spinner fa-spin" :class="classes ? classes : ''"></i>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LoadingAnimation',
    mounted() {},
    props: {
        animationStyle: {
            type: String,
            required: true,
        },
        classes: String,
    },
    methods: {},
    data() {
        return {};
    },
};
</script>
